import {
  InventoryTransferSchema,
  InventoryTransferStatusSchema,
} from "@redotech/redo-model/inventory/inventory";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getInventoryTransfers = unaryRpc({
  name: "getInventoryTransfers" as const,
  input: z.object({
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(100).default(20),
    status: InventoryTransferStatusSchema.optional(),
    verified: z.boolean().optional(),
  }),
  output: z.object({
    transfers: z.array(InventoryTransferSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});
